/* eslint-disable max-lines, max-depth */
import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactLoading from "../Loading";
import L10NFactory from "../../utils/L10NFactory";
import ajax from "../../utils/ajax";
import components from "../index";
import L10n from "../../utils/l10n";
import g from "../../utils/globals";
import Logger from "../../utils/Logger";
import cookies from "../../utils/cookies";
import { bundleImport } from "../../utils/polyfills";

const logger = new Logger(__filename);

class withDependencies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      render: true,
    };
    this.l10n = new L10n({}, g.locale);
    this.customHTML = this.props.customHTML;
    this.fullHTML = null;
    this.partialHTML = null;
    this.contents = [];
  }

  componentWillMount = () => this.loadDependencies();

  componentWillReceiveProps = nextProps => {
    if (nextProps.contents !== this.props.contents) {
      this.translate(nextProps.contents);
    }
  };

  componentWillUnmount = () => {
    try {
      this.disposeEnhancement();
    } catch (error) {
      logger.error(`Error disposing: [Enhancement]`);
      logger.debug(error);
    }
  };

  mustRenderHandler = x => {
    if (x.attributes.when.arg1.indexOf("?") > -1) {
      const [key, value] = x.attributes.when.arg1.split("=");
      const translateExist = this.l10n.t(key.slice(0, -1));
      if ((translateExist.length > 0 && value === "true") || (translateExist.length === 0 && value === "false")) {
        return true;
      }
      return false;
    }
    const [key, value] = x.attributes.when.arg1.split("=");
    const translate = this.l10n.t(key);
    return translate && value === String(translate);
  };

  translate = contents => {
    const translated = contents.filter(x => {
      if (!x) return false;
      if (x.attributes) {
        const mustRender = !x.attributes.when.arg1 ? true : this.mustRenderHandler(x);
        if (!mustRender) {
          return false;
        }
      }
      if (x.module === "SocialWidget") {
        if (x.attributes.l10n.arg1) {
          let key = x.attributes.l10n.arg1;
          x.hashtag = this.l10n.t(key);
          key = key.replace("hashtag", "description");
          x.content = this.l10n.t(key);
          if (!x.content) {
            let tokens = window.document.title.split("-");
            tokens.pop();
            if (tokens.length > 1) {
              tokens = tokens.reverse().join(" - ");
            }
            x.content = `${x.hashtag} - ${tokens}`;
          }
          key = key.replace("description", "image");
          x.media = this.l10n.t(key);
        } else {
          x.meta.contents.replace(/#\s+#/, "");
        }
      }
      if (/Text|LayoutText/.test(x.module) || x.module === "SocialWidget") {
        x.text = x.attributes.l10n.arg1 ? this.l10n.t(x.attributes.l10n.arg1) : x.text || "";
      }
      const contents = x.contents || x.children;
      if (contents) this.translate(contents);
      return true;
    });
    this.contents = translated;
  };

  loadDicts = () => {
    if (!this.props.dict) return;
    return new Promise(resolve => {
      L10NFactory.get(this.props.dict).then(l10n => {
        this.l10n.setup(l10n.dict);
        resolve();
      });
    });
  };

  loadStyles = (src, id) => {
    let link = document.querySelector(`#${id}-styles`);
    if (link) link.remove();
    link = document.createElement("link");
    link.id = `#${id}-styles`;
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = src;
    link.media = "all";
    document.head.appendChild(link);
    this.style = link;
    link.onload = () => {
      this.setState({
        render: true,
      });
    };
  };
  loadEnhancement = () => {
    this.enhancement = null;
    if (!this.props.enhancement) return;
    if (typeof this.props.enhancement === "object") {
      return (this.enhancement = this.props.enhancement);
    }
    const localStorie = cookies.read("edge3");
    return new Promise(resolve => {
      let basePath = `${localStorie || `${g.staticContent}`}/contents/${this.props.enhancement}`;
      let bundle = bundleImport(
        `${basePath}/index.js?ts=${g.lastStaticSyncTimestamp}`,
        `storie_${this.props.enhancement}`,
        this.props.enhancement
      );
      if (bundle) {
        bundle
          .then(async mod => {
            this.enhancement = await Promise.resolve(mod.default);

            this.content = (this.props.dataAttrs && this.enhancement[this.props.dataAttrs["data-content"]]) || {};
            if (this.enhancement.style) {
              this.setState({
                render: false,
              });
              this.loadStyles(`${basePath}/index.css?ts=${g.lastStaticSyncTimestamp}`, this.props.enhancement);
            }
            if (this.enhancement.pixelRatioImgs) {
              g.setGlobals({ pixelRatioImgs: this.enhancement.pixelRatioImgs });
            }
            if (this.enhancement.videoRatio) {
              g.setGlobals({ videoRatio: this.enhancement.videoRatio });
            }
            this.enhancementDictHandler().then(() => {
              resolve({
                contents: (this.enhancement.dict || this.content.dict) && !this.customHTML ? this.props.contents : null,
                customHTML: this.customHTML,
                fullHTML: this.fullHTML,
                partialHTML: this.partialHTML,
              });
            });
          })
          .catch(error => {
            logger.error(error.message);
            logger.error(error.stack);
            resolve();
          });
      } else {
        resolve(false);
      }
    });
  };

  enhancementHtmlHandler = () => {
    this.fullHTML = this.enhancement.fullHTML || this.content.fullHTML;
    if (!this.fullHTML) return;
    const html = this.enhancement.html || this.content.html;
    const data = this.props.contents && this.props.contents[0];
    const walk = node => {
      if (node.children && node.children.length) {
        node.children.forEach(walk);
      } else {
        if (node.module === "Img") {
          this.l10n.setup({ en_GB: { [node.name || node.id]: node.attrs.src } });
        }
        if (/Text|LayoutText|Link/.test(node.module)) {
          this.l10n.setup({ en_GB: { [node.name || node.id]: node.href || node.characters } });
        }
      }
    };
    if (data) walk(data);
    this.partialHTML = this.enhancement.partialHTML || this.content.partialHTML;
    const legacyName = html === "mobHtmlTmpl" || html === "htmlTmpl";
    this.customHTML = legacyName ? this.l10n.t(html) : this.l10n.resolve(html);
    const replaceWord = this.enhancement.replaceWord || this.content.replaceWord;
    if (replaceWord) {
      this.customHTML = replaceWord(this.customHTML);
    }
  };

  enhancementDictHandler = () => {
    const remoteDataSourceLoads = [];
    if (this.enhancement.dict) {
      remoteDataSourceLoads.push(L10NFactory.get(this.enhancement.dict));
    }
    if (this.content && this.content.dict) {
      remoteDataSourceLoads.push(L10NFactory.get(this.content.dict));
    }
    return Promise.all(remoteDataSourceLoads)
      .then(remoteDataSources => {
        const dataSources = remoteDataSources.concat([
          this.enhancement.urls,
          this.enhancement.dictExtension,
          this.content?.urls,
          this.content?.dictExtension,
          this.props.contents?.[0]?.extensions?.urls || {},
          this.props.contents?.[0]?.extensions?.dictExtension || {},
        ]);
        dataSources.forEach(ds => {
          if (ds) {
            this.l10n.setup(ds.dict || ds);
          }
        });
      })
      .then(() => this.enhancementHtmlHandler());
  };

  loadData = () => {
    this.data = null;
    if (!this.props.data) return;
    return new Promise(resolve => {
      const data = this.props.data === true ? this.props.name : this.props.data;
      if (!data) resolve();
      logger.log(`requesting remote data for ${data}`);
      const url = data;
      ajax.get(url, data => {
        this.data = data;
        resolve();
      });
    });
  };

  loadDependencies = () => {
    const promises = [];

    promises.push(this.loadDicts());
    promises.push(this.loadEnhancement());
    promises.push(this.loadData());

    Promise.all(promises).then(response => {
      let customHTML = false;
      let fullHTML = false;
      let partialHTML = false;
      const parsedResponse = Object.assign({}, ...response.filter(resp => typeof resp !== "undefined"));
      if (parsedResponse.contents || this.props.contents) {
        if (this.enhancement && this.enhancement.overrideDictKeys) {
          this.enhancement.overrideDictKeys(this.l10n);
          if (parsedResponse.contents) this.translate(parsedResponse.contents);
        }
        this.translate(this.props.contents);
      }
      if (this.enhancement) {
        if (parsedResponse.customHTML) {
          customHTML = parsedResponse.customHTML;
          fullHTML = parsedResponse.fullHTML;
          partialHTML = parsedResponse.partialHTML;
        }
      }
      this.setState({
        loading: false,
        customHTML,
        fullHTML,
        partialHTML,
      });
    });
  };

  disposeEnhancement = () => {
    if (this.style) {
      logger.log(`disposing enhanced <style> [${this.props.attrs.id}]`);
      if (this.style instanceof HTMLElement) {
        this.style.remove();
      } else {
        this.style.unuse();
      }
    }
    if (this.enhancement) {
      if (this.enhancement.dispose) {
        try {
          this.enhancement.dispose();
        } catch (error) {
          logger.error(`Error disposing: [${this.props.attrs.id}]`);
          logger.debug(error);
        }
      }
      g.enhancementsLoaded = [];
    }
  };

  render = () => {
    let fullHTML = this.state.fullHTML;
    const dataContent = this.props.dataAttrs && this.props.dataAttrs["data-content"];
    const contentEnhancement = this.enhancement && this.enhancement[dataContent];
    if (contentEnhancement) {
      fullHTML = contentEnhancement.fullHTML;
      if (contentEnhancement.svgs) {
        Object.keys(contentEnhancement.svgs).map(elm =>
          this.props.contents.map(content => {
            if (content.id.indexOf(elm) > -1) {
              content.module = "Svg";
              content.svg = contentEnhancement.svgs[elm];
            }
            return content;
          })
        );
      }
    }
    if (this.state.loading) {
      return <ReactLoading type="spin" />;
    }
    window.props = this.props;

    let module = this.props.module;
    if (fullHTML) module = "HTML";

    const Module = components[module];
    let props = this.props;

    if (this.contents.length > 0) {
      props = Object.assign({}, this.props, {
        contents: this.contents,
      });
    }
    if (this.enhancement && this.enhancement.beforeRender) {
      const options = {
        l10n: this.l10n,
        props: JSON.parse(JSON.stringify(props)),
      };
      this.enhancement.beforeRender(options);
      props = options.props;
    }
    const firstContent = this.props.contents && this.props.contents[0];
    return (
      this.state.render && (
        <Module
          {...props}
          customHTML={this.customHTML || this.state.customHTML}
          enhancementName={this.props.enhancement}
          partialHTML={this.state.partialHTML}
          active={this.props.active}
          enhancement={this.enhancement}
          data={this.data}
          dataAttrs={props.dataAttrs || {}}
          l10n={this.l10n}
          root={
            this.props.root || {
              path: firstContent && firstContent.root,
              ts: firstContent && firstContent.timestamp,
            }
          }
        />
      )
    );
  };
}

withDependencies.propTypes = {
  attrs: PropTypes.shape({
    id: PropTypes.string,
  }),
  dict: PropTypes.any,
  enhancement: PropTypes.any,
  data: PropTypes.any,
  name: PropTypes.string,
  contents: PropTypes.array,
};

export default withDependencies;
